import { Link, useNavigate } from "react-router-dom";
import { Instagram, Music2, Facebook, Youtube, Mail } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";

export default function Footer({ settings = {} }) {
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const socials = [
    { icon: Instagram, url: settings.instagram, label: "Instagram" },
    { icon: Music2, url: settings.tiktok, label: "TikTok" },
    { icon: Facebook, url: settings.facebook, label: "Facebook" },
    { icon: Youtube, url: settings.youtube, label: "YouTube" },
    { icon: Mail, url: settings.email ? `mailto:${settings.email}` : null, label: "Email" },
  ].filter((s) => s.url);

  const jump = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-[#070809] border-t border-white/10 grain overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <img src={LOGO_URL} alt="LUHAI" className="h-10 mb-5" />
            <p className="font-mono2 text-xs tracking-[0.25em] text-[#02AACF] uppercase">Not Your Average Photographer</p>
            <p className="text-[#94A3B8] mt-3 max-w-xs">Nassau, Bahamas. Bold, authentic imagery built around real people, real moments and real energy.</p>
            <div className="flex gap-3 mt-6">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:border-[#02AACF] hover:text-[#02AACF] hover:-translate-y-1 transition-all"
                >
                  <s.icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono2 text-xs tracking-[0.25em] text-white/50 uppercase mb-5">Explore</p>
            <ul className="space-y-3 text-[#94A3B8]">
              <li><button onClick={() => navigate("/work")} className="hover:text-white transition-colors" data-testid="footer-link-work">Work</button></li>
              <li><button onClick={() => { navigate("/"); setTimeout(() => jump("packages"), 300); }} className="hover:text-white transition-colors" data-testid="footer-link-packages">Packages</button></li>
              <li><button onClick={() => { navigate("/"); setTimeout(() => jump("about"), 300); }} className="hover:text-white transition-colors" data-testid="footer-link-about">About</button></li>
              <li><button onClick={() => navigate("/contact")} className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</button></li>
              <li><button onClick={() => navigate("/book")} className="hover:text-white transition-colors" data-testid="footer-link-book">Book</button></li>
            </ul>
          </div>

          <div>
            <p className="font-mono2 text-xs tracking-[0.25em] text-white/50 uppercase mb-5">Legal</p>
            <ul className="space-y-3 text-[#94A3B8]">
              <li><button onClick={() => navigate("/privacy")} className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</button></li>
              <li><button onClick={() => navigate("/terms")} className="hover:text-white transition-colors" data-testid="footer-terms">Terms &amp; Conditions</button></li>
              <li><button onClick={() => navigate("/booking-policy")} className="hover:text-white transition-colors" data-testid="footer-booking-policy">Booking Policy</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#64748B]">© {year} LUHAI. All rights reserved.</p>
          <Link to="/admin" className="text-xs text-[#64748B] hover:text-[#02AACF] font-mono2 transition-colors" data-testid="footer-admin-link">
            ADMIN
          </Link>
        </div>
      </div>

      <div className="pointer-events-none select-none w-full overflow-hidden">
        <p className="font-display font-bold text-[22vw] leading-[0.75] text-white/[0.03] text-center -mb-[3vw]">luhai</p>
      </div>
    </footer>
  );
}
